<div class="row g-3">
  <!-- Panel principal del árbol -->
  <div [ngClass]="showDetails ? 'col-12 col-lg-6' : 'col-12'">
    <mat-card appearance="outlined">
      <!-- Cabecera -->
      <mat-card-header class="flex-column flex-md-row align-items-start align-items-md-center">
        <div mat-card-avatar>
          <mat-icon>account_tree</mat-icon>
        </div>
        <mat-card-title>Administración - Menús Desplegables</mat-card-title>
        <mat-card-subtitle class="d-none d-md-block">Gestión de casos de uso con vista de árbol</mat-card-subtitle>
        <div class="flex-grow-1"></div>

        <button mat-icon-button (click)="toggleStats()" matTooltip="Estadísticas" [color]="showStats ? 'accent' : ''">
          <mat-icon>bar_chart</mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menuOptions" matTooltip="Opciones">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #menuOptions="matMenu">
          <button mat-menu-item (click)="expandAll()">
            <mat-icon>unfold_more</mat-icon>
            <span>Expandir todo</span>
          </button>
          <button mat-menu-item (click)="collapseAll()">
            <mat-icon>unfold_less</mat-icon>
            <span>Colapsar todo</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="toggleCompactMode()">
            <mat-icon>{{ isCompactMode ? 'view_comfortable' : 'view_compact' }}</mat-icon>
            <span>{{ isCompactMode ? 'Modo Normal' : 'Modo Compacto' }}</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="exportConfiguration()">
            <mat-icon>download</mat-icon>
            <span>Exportar configuración</span>
          </button>
        </mat-menu>
      </mat-card-header>

      <!-- Contenido -->
      <mat-card-content class="pt-3">
        <ngx-spinner [zIndex]="100" name="spListado" bdColor="rgba(255,255,255,0.8)" size="default"
          color="var(--primary-color)" type="ball-atom" [fullScreen]="false"></ngx-spinner>

        <!-- Panel de estadísticas -->
        @if (showStats) {
        <mat-card appearance="outlined" class="bg-light mb-3" @fadeIn>
          <mat-card-content class="pt-3">
            <h6 class="d-flex align-items-center mb-3">
              <mat-icon class="me-2">analytics</mat-icon>
              <strong>Estadísticas del Árbol</strong>
            </h6>
            <div class="row g-3">
              <div class="col-6 col-md-4 col-lg-2">
                <mat-card appearance="outlined" class="text-center">
                  <mat-card-content class="p-2">
                    <mat-icon color="primary">inventory_2</mat-icon>
                    <div class="fs-4 fw-bold">{{ stats.totalNodes }}</div>
                    <small class="text-muted text-uppercase">Total</small>
                  </mat-card-content>
                </mat-card>
              </div>
              <div class="col-6 col-md-4 col-lg-2">
                <mat-card appearance="outlined" class="text-center">
                  <mat-card-content class="p-2">
                    <mat-icon class="text-success">visibility</mat-icon>
                    <div class="fs-4 fw-bold">{{ stats.visibleNodes }}</div>
                    <small class="text-muted text-uppercase">Visibles</small>
                  </mat-card-content>
                </mat-card>
              </div>
              <div class="col-6 col-md-4 col-lg-2">
                <mat-card appearance="outlined" class="text-center">
                  <mat-card-content class="p-2">
                    <mat-icon class="text-muted">visibility_off</mat-icon>
                    <div class="fs-4 fw-bold">{{ stats.hiddenNodes }}</div>
                    <small class="text-muted text-uppercase">Ocultos</small>
                  </mat-card-content>
                </mat-card>
              </div>
              <div class="col-6 col-md-4 col-lg-2">
                <mat-card appearance="outlined" class="text-center">
                  <mat-card-content class="p-2">
                    <mat-icon class="text-success">check_circle</mat-icon>
                    <div class="fs-4 fw-bold">{{ stats.enabledNodes }}</div>
                    <small class="text-muted text-uppercase">Habilitados</small>
                  </mat-card-content>
                </mat-card>
              </div>
              <div class="col-6 col-md-4 col-lg-2">
                <mat-card appearance="outlined" class="text-center">
                  <mat-card-content class="p-2">
                    <mat-icon class="text-danger">cancel</mat-icon>
                    <div class="fs-4 fw-bold">{{ stats.disabledNodes }}</div>
                    <small class="text-muted text-uppercase">Deshabilitados</small>
                  </mat-card-content>
                </mat-card>
              </div>
              <div class="col-6 col-md-4 col-lg-2">
                <mat-card appearance="outlined" class="text-center">
                  <mat-card-content class="p-2">
                    <mat-icon color="primary">menu</mat-icon>
                    <div class="fs-4 fw-bold">{{ stats.menuDesplegables }}</div>
                    <small class="text-muted text-uppercase">Menús</small>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        }

        <div class="row g-3">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Buscar en árbol</mat-label>
              <mat-icon matPrefix class="me-1">search</mat-icon>
              <input matInput [(ngModel)]="filterText" (input)="filterTree()" placeholder="Nombre, descripción..." />
            </mat-form-field>
          </div>
        </div>

        <!-- Filtros Avanzados -->
        @if (showAdvancedFilters) {
        <div class="row g-3">
          <div class="col-12 col-md-6">
            <h6 class="text-muted mb-2 d-flex align-items-center">
              <mat-icon class="align-middle me-1 small-icon">visibility</mat-icon>
              Visibilidad
            </h6>
            <div class="d-flex flex-column gap-2 mb-3">
              <mat-checkbox [(ngModel)]="advancedFilters.showVisible" (change)="applyAdvancedFilters()"
                color="primary">
                Mostrar visibles
              </mat-checkbox>
              <mat-checkbox [(ngModel)]="advancedFilters.showHidden" (change)="applyAdvancedFilters()"
                color="primary">
                Mostrar ocultos
              </mat-checkbox>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <h6 class="text-muted mb-2 d-flex align-items-center">
              <mat-icon class="align-middle me-1 small-icon">toggle_on</mat-icon>
              Estado
            </h6>
            <div class="d-flex flex-column gap-2 mb-3">
              <mat-checkbox [(ngModel)]="advancedFilters.showEnabled" (change)="applyAdvancedFilters()"
                color="primary">
                Mostrar habilitados
              </mat-checkbox>
              <mat-checkbox [(ngModel)]="advancedFilters.showDisabled" (change)="applyAdvancedFilters()"
                color="primary">
                Mostrar deshabilitados
              </mat-checkbox>
            </div>
          </div>
        </div>
        <div class="row g-3">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>
                <mat-icon class="align-middle me-1 small-icon">description</mat-icon>
                Descripción
              </mat-label>
              <input matInput type="text" [(ngModel)]="advancedFilters.descripcion"
                (ngModelChange)="onAdvancedTextFilterChange()" placeholder="Filtrar por descripción..." />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>
                <mat-icon class="align-middle me-1 small-icon">note</mat-icon>
                Observaciones
              </mat-label>
              <input matInput type="text" [(ngModel)]="advancedFilters.observaciones"
                (ngModelChange)="onAdvancedTextFilterChange()" placeholder="Filtrar por observaciones..." />
            </mat-form-field>
          </div>
        </div>
        }

        <div class="mt-1 row align-items-center g-2">
          <div class="col-auto">
            <div style="display: flex; align-items: center; gap: 8px;">
              <app-button-filter-table (click)="filterTree()"></app-button-filter-table>
              <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
            </div>
          </div>
          <div class="col-auto">
            <mat-slide-toggle (change)="toggleAdvancedFilters($event)" color="primary">
              Filtros Avanzados
            </mat-slide-toggle>
          </div>
        </div>

        <mat-divider class="my-3"></mat-divider>

        <!-- Árbol de navegación -->
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" [class.compact-mode]="isCompactMode"
          class="mat-elevation-z1">
          <!-- Nodo hoja -->
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [ngClass]="{
              'opacity-50': node.casoUso && !node.casoUso.visible,
              'text-decoration-line-through text-muted': node.casoUso && !node.casoUso.habilitado
            }">
            <button mat-icon-button disabled></button>
            <mat-icon class="me-2" color="primary">{{ node.icon }}</mat-icon>

            <span class="d-flex align-items-center justify-content-between flex-grow-1">
              <a [routerLink]="getFullUrl(node)"
                class="text-decoration-none text-dark flex-grow-1 d-flex align-items-center gap-2">
                {{ node.name }}

                <span class="d-flex gap-1">
                  @if (node.casoUso && !node.casoUso.visible) {
                  <mat-icon class="icon-hover text-muted small-icon" matTooltip="Oculto">
                    visibility_off
                  </mat-icon>
                  }
                  @if (node.casoUso && !node.casoUso.habilitado) {
                  <mat-icon class="icon-hover text-danger small-icon" matTooltip="Deshabilitado">
                    block
                  </mat-icon>
                  }
                </span>
              </a>

              <button mat-icon-button [matMenuTriggerFor]="nodeMenu" aria-label="Acciones">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #nodeMenu="matMenu">
                <button mat-menu-item (click)="onNodeClick(node)">
                  <mat-icon>launch</mat-icon>
                  <span>Ir a gestión</span>
                </button>
              </mat-menu>
            </span>
          </mat-tree-node>

          <!-- Nodo padre con hijos -->
          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
            <div class="mat-tree-node bg-light" matTreeNodePadding>
              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon class="tree-toggle-icon" [class.rotate-90]="treeControl.isExpanded(node)">
                  chevron_right
                </mat-icon>
              </button>
              <mat-icon class="me-2" color="primary">{{ node.icon }}</mat-icon>
              <span class="d-flex align-items-center gap-2 flex-grow-1 fw-bold">
                {{ node.name }}
                @if (node.children) {
                <mat-chip class="m-0 chip-compact">
                  {{ node.children.length }}
                </mat-chip>
                }
              </span>
            </div>

            @if (treeControl.isExpanded(node)) {
            <div @expandCollapse>
              <ng-container matTreeNodeOutlet></ng-container>
            </div>
            }
          </mat-nested-tree-node>
        </mat-tree>

        <!-- Sin resultados -->
        @if (dataSource.data.length === 0) {
        <div class="text-center py-5 text-muted">
          <mat-icon class="empty-state-icon">search_off</mat-icon>
          <p class="mt-3 mb-3">No se encontraron resultados</p>
          <button mat-raised-button color="primary" (click)="limpiarFiltro()">
            Limpiar filtros
          </button>
        </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
